<template>
    <div>
        <app-nav/>
        <main>
            <section>
                <div class="row d-flex justify-content-center m-0 p-0">
                    <div class="col taust w-100">
                        <div class="row d-flex mob-bg justify-content-center m-0 p-0 wow fadeIn">
                            <div class="col top-m-p text-center w-100">
                                <h1 class="display-5 font-weight-normal mt-1 mb-4 custom-mob-bg">
                                    {{ $t('Renting') }}
                                </h1>
                                <div v-if="page" class="container text-left" v-html="page[locale]"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <app-footer/>
    </div>
</template>

<script>
import AppNav from '@components/layout/public/Nav';
import AppFooter from '@components/layout/public/Footer';
import PublicPageService from '@services/publicPage.service';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            page: null
        };
    },
    computed: {
        ...mapGetters(['locale'])
    },
    methods: {
        getPage() {
            PublicPageService.publicShow('renting').then(res => {
                this.page = res;
            });
        }
    },
    components: {
        AppNav,
        AppFooter
    },
    created() {
        this.getPage();
    },
    metaInfo() {
        return {
            title: `${this.$t('Renting')} | Autorent OÜ`
        };
    }
};
</script>
